///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';

import { GtthBomReportService } from '../../bom_report/bom-report.service';
import { GtthReportsTabs } from '../reports-tabs.enum';
import { GtthHistoryService } from '../../../logical-topology/engine/history-service';
import { ExtendedBomDeviceDTO } from '../../bom_report/dto/extended-bom-device-dto.model';

@Injectable({ providedIn: 'root' })
export class GtthAnIpInfoService {
    constructor(
        private readonly bomReportService: GtthBomReportService,
        private readonly historyService: GtthHistoryService
    ) {}

    public getAllReportNodesList(activeLayer: number, tab: GtthReportsTabs): string[] {
        return this.bomReportService.getBomNodeNames(activeLayer, tab);
    }

    public isMhTg(type: number): boolean {
        return this.historyService.projectProductsService.isMhTgDevice(type);
    }

    public getNodeAnIpData(activeLayer, tab: GtthReportsTabs, nodeName: string): ExtendedBomDeviceDTO[] {
        return this.bomReportService.getExtendedNodeDevices(activeLayer, nodeName).filter((deviceData: ExtendedBomDeviceDTO) => {
            if (!this.isMhTg(deviceData.type)) {
                return false;
            }
            switch (tab) {
                case GtthReportsTabs.NEW:
                    return !deviceData.userForced && !deviceData.installed;
                case GtthReportsTabs.INSTALLED:
                    return deviceData.installed;
                default:
                    return true;
            }
        });
    }
}
